import React, { type ReactNode } from "react"
import { View } from "react-native"
import { CalculationSectionTitle } from "@/components/analysis/calculate/CalculationTitles"

interface CalculateCardProps {
  title: string
  children: ReactNode
  className?: string
}

const CalculateCard: React.FC<CalculateCardProps> = ({
  title,
  children,
  className,
}) => {
  return (
    <View className={`mb-6 ${className}`}>
      <CalculationSectionTitle title={title} />
      <View className="p-4 bg-white rounded-md border border-gray-200">
        {children}
      </View>
    </View>
  )
}

export default CalculateCard
